module.exports = __webpack_public_path__ + "static/media/erheritage.621e554d.svg";